export function CountryPricing() {
  const countries = [
    {
      flag: '🇺🇸',
      name: 'United States',
      code: '+1',
      price: '$0.05',
      popular: true,
    },
    {
      flag: '🇬🇧',
      name: 'United Kingdom',
      code: '+44',
      price: '$0.07',
      popular: false,
    },
    {
      flag: '🇩🇪',
      name: 'Germany',
      code: '+49',
      price: '$0.06',
      popular: false,
    },
    { flag: '🇫🇷', name: 'France', code: '+33', price: '$0.06', popular: false },
    { flag: '🇷🇺', name: 'Russia', code: '+7', price: '$0.04', popular: true },
    { flag: '🇮🇳', name: 'India', code: '+91', price: '$0.03', popular: true },
    { flag: '🇧🇷', name: 'Brazil', code: '+55', price: '$0.05', popular: false },
    { flag: '🇨🇦', name: 'Canada', code: '+1', price: '$0.05', popular: false },
    {
      flag: '🇦🇺',
      name: 'Australia',
      code: '+61',
      price: '$0.08',
      popular: false,
    },
    { flag: '🇯🇵', name: 'Japan', code: '+81', price: '$0.09', popular: false },
    {
      flag: '🇳🇱',
      name: 'Netherlands',
      code: '+31',
      price: '$0.06',
      popular: false,
    },
    { flag: '🇸🇪', name: 'Sweden', code: '+46', price: '$0.07', popular: false },
  ]
  

  return (
    <section
      id="country-pricing"
      style={{ padding: '120px 24px', maxWidth: '1200px', margin: '0 auto' }}
    >
      <div style={{ textAlign: 'center', marginBottom: '64px' }}>
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            background: '#F0FDF9',
            border: '1px solid #A7F3D0',
            borderRadius: '100px',
            padding: '6px 16px',
            marginBottom: '20px',
          }}
        >
          <span
            style={{
              fontSize: '12px',
              letterSpacing: '0.5px',
              color: '#059669',
              fontWeight: '600',
            }}
          >
            Global Coverage
          </span>
        </div>
        <h2
          style={{
            fontSize: 'clamp(28px, 3.5vw, 46px)',
            fontWeight: '800',
            letterSpacing: '-1px',
            color: '#0F172A',
            margin: '0 0 16px',
          }}
        >
          Numbers from{' '}
          <span
            style={{
              background: 'linear-gradient(135deg, #059669, #3B82F6)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            150+ Countries
          </span>
        </h2>
        <p
          style={{
            fontSize: '17px',
            color: '#6B7280',
            maxWidth: '440px',
            margin: '0 auto',
          }}
        >
          Ultra-low pricing with no subscriptions across 150+ countries.
        </p>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
          gap: '14px',
        }}
      >
        {countries.map((country) => (
          <div
            key={country.name}
            style={{
              background: 'white',
              border: country.popular
                ? '1.5px solid #BFDBFE'
                : '1.5px solid #E5E7EB',
              borderRadius: '16px',
              padding: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              transition: 'all 0.25s ease',
              cursor: 'pointer',
              position: 'relative',
              overflow: 'hidden',
              boxShadow: country.popular
                ? '0 2px 12px rgba(59,130,246,0.08)'
                : '0 1px 4px rgba(0,0,0,0.04)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-3px)'
              e.currentTarget.style.borderColor = '#3B82F6'
              e.currentTarget.style.boxShadow =
                '0 8px 24px rgba(59,130,246,0.14)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)'
              e.currentTarget.style.borderColor = country.popular
                ? '#BFDBFE'
                : '#E5E7EB'
              e.currentTarget.style.boxShadow = country.popular
                ? '0 2px 12px rgba(59,130,246,0.08)'
                : '0 1px 4px rgba(0,0,0,0.04)'
            }}
          >
            {country.popular && (
              <div
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '10px',
                  background: '#EFF6FF',
                  border: '1px solid #BFDBFE',
                  borderRadius: '6px',
                  padding: '2px 8px',
                  fontSize: '10px',
                  fontWeight: '700',
                  color: '#3B82F6',
                  letterSpacing: '0.5px',
                }}
              >
                HOT
              </div>
            )}
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <span style={{ fontSize: '28px' }}>{country.flag}</span>
              <div>
                <div
                  style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#111827',
                  }}
                >
                  {country.name}
                </div>
                <div
                  style={{
                    fontSize: '12px',
                    color: '#9CA3AF',
                    marginTop: '2px',
                  }}
                >
                  {country.code}
                </div>
              </div>
            </div>
            <div
              style={{ fontSize: '18px', fontWeight: '800', color: '#3B82F6' }}
            >
              {country.price}
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
